const Contact=() => {
    return(
        <h1>
            This is an Contact Us Page!!
        </h1>
    )
}

export default Contact;